/* eslint-disable indent */
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AirportWeatherView } from '@flight-details/weather/models/airport-weather.view';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-station-wx',
  templateUrl: './station-wx.component.html',
  styleUrls: ['./station-wx.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StationWxComponent {
  @Input() airportWeather?: AirportWeatherView;
  @Input() departureTime?: DateTime | null;
  @Input() arrivalTime?: DateTime | null;

  getStationTitle(): string {
    if (this.airportWeather) {
      let typeText = '';

      switch (this.airportWeather.station.type) {
        case 'dep':
          typeText = 'Dep';
          break;
        case 'arr':
          typeText = 'Arr';
          break;
        case 'alt':
          typeText = 'Alt';
          break;
        case 'to_alt':
          typeText = 'T/O Alt';
          break;
        default:
          break;
      }

      return `${this.airportWeather.station.id} (${typeText})`;
    }

    return '';
  }
}
